const TOKEN_KEY = "token";
export const IDLE_TIME = "idle_time";

export const saveToken = (token: string) => {
  window.dispatchEvent(new Event("storage update"));
  window.localStorage.setItem(TOKEN_KEY, token);
};

export const removeToken = () => {
  window.dispatchEvent(new Event("storage update"));
  window.localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => {
  // Check if window.localStorage is available
  if (window.localStorage) {
    return window.localStorage.getItem(TOKEN_KEY);
  } else {
    // Handle the case when localStorage is not available
    return null;
  }
};

export const setItem = ({
  key,
  value,
  shouldDispatchEvent = true,
}: {
  key: string;
  value: string;
  shouldDispatchEvent?: boolean;
}) => {
  if (shouldDispatchEvent) {
    window.dispatchEvent(new Event("storage update"));
  }

  window.localStorage.setItem(key, value);
};

export const getItem = (key: string) => {
  return window.localStorage.getItem(key);
};

export const clear = () => {
  window.dispatchEvent(new Event("storage update"));
  return window.localStorage.clear();
};
